export default __webpack_public_path__ + "static/media/view.0bcfc267.svg";